import React from 'react';
import './Page6.css';

const Page6 = () => {
  return (
    <div className='page6-section'>
      <h2 className="page6-heading">News</h2>
       <div className='underline'></div>
      <div className='page6-container'>

        <div className='page6-news'>
          <div className='page6-text'>
            
          <a href="https://timesofindia.indiatimes.com/business/india-business/iit-m-team-working-to-help-india-lead-in-spatial-computing/articleshow/115873052.cms" className='page6-title' target='_blank'>IIT-M team working to help India lead in spatial computing</a>
             <p className='page6-summary'>
                             As adoption of artificial intelligence (AI) technology is going on apace, a group of academics and entrepreneurs at IIT-M is working on the next potential big thing --spatial computing. 
            </p>
            <p className='page6-source'>The Times of India</p>
          </div>
           <a href="https://timesofindia.indiatimes.com/business/india-business/iit-m-team-working-to-help-india-lead-in-spatial-computing/articleshow/115873052.cms" target='_blank'>
          <img src="images/news1.webp" alt="news1" className='page6-image' />
          </a>
        </div>

        <hr className="page6-divider" />

        <div className='page6-news'>
          <div className='page6-text'>

            <a href='https://blog.google/products/android/android-xr-gemini-glasses-headsets/' className='page6-title' target='_blank'>A new look at how Android XR will bring Gemini to glasses and headsets</a>
            <p className='page6-summary'>
               AI and XR are coming together. See how glasses running Android XR are making AI even easier to use and creating new experiences.
                   </p>
             <p className='page6-source'> Android Authority
            </p>
          </div>
          <a href="https://blog.google/products/android/android-xr-gemini-glasses-headsets/" target='_blank'>
          <img src="images/news2.webp" alt="news2" className='page6-image'/>
          </a>
        </div>
        <hr className="page6-divider" />

        <div className='page6-news'>
          <div className='page6-text'>
            <a href='https://geospatialworld.net/videos/conference/spatial-computing-and-digital-twin-gwf-2025/' className='page6-title' target='_blank'>How Spatial Computing & AI are Transforming Nations | Sanjay Kumar’s Keynote at GWF 2025</a>
            <p className='page6-summary'>
                    Join Sanjay Kumar, Founder & CEO of Geospatial World, as he opens GWF 2025, held from April 22–25 in Madrid, Spain, with a powerful keynote on the emerging era of spatial computing, digital twins, and geospatial sovereignty.
            </p>
            <p className='page6-source'>Geospatial World</p>
          </div>
          <a href="https://geospatialworld.net/videos/conference/spatial-computing-and-digital-twin-gwf-2025/" target='_blank'>
          <img src="images/news3.webp" alt="news3" className='page6-image'/>
          </a>
        </div>
        <hr className="page6-divider" />

        <div className='page6-news'>
          <div className='page6-text'>
            <a href='https://www.forbes.com/sites/charliefink/2025/05/23/curtain-raiser-awe-2025-brings-xr-into-the-mainstream/' className='page6-title' target='_blank'>Curtain Raiser: AWE 2025 Brings XR Into The Mainstream</a>
            <p className='page6-summary'>
             Augmented World Expo (AWE) returns to Long Beach from June 10 to 12, 2025, with its most expansive and ambitious edition to date.
            </p>
            <p className='page6-source'>Forbes</p>
            
          </div>
          <a href="https://www.forbes.com/sites/charliefink/2025/05/23/curtain-raiser-awe-2025-brings-xr-into-the-mainstream/" target='_blank'>
          <img src="images/news4.webp" alt="news4" className='page6-image'/>
          </a>
        </div>
        <hr className="page6-divider" />


      </div>
    </div>
  );
};

export default Page6;
